import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const skeletonHighlightColor = 'var(--primary400)';

export type SkeletonPlaceholderProps = {
  width: number | string;
  height?: number | string;
  count?: number;
  borderRadius?: number;
  baseColor?: string;
};
export const SkeletonPlaceholder = ({
  width = 100,
  height = 16,
  count = 1,
  borderRadius = 4,
  baseColor = skeletonHighlightColor,
}: SkeletonPlaceholderProps) => (
  <Skeleton
    width={width}
    count={count}
    height={height}
    baseColor={baseColor}
    borderRadius={borderRadius}
    highlightColor={baseColor}
  />
);

export default SkeletonPlaceholder;
